module.exports = __webpack_public_path__ + "img/id.b5f56e3b.png";